/** Japanese labels for accuracy report / evaluation run statuses (wire values stay English). */
export function formatAccuracyStatusLabel(status: string): string {
  switch (status) {
    case 'completed':
      return '完了';
    case 'running':
      return '処理中';
    case 'queued':
      return '待機中';
    case 'failed':
      return '失敗';
    case 'detecting':
      return '検出中';
    case 'matching':
      return '評価中';
    case 'active':
      return '進行中';
    case 'published':
      return '公開済み';
    case 'archived':
      return 'アーカイブ';
    default:
      return status;
  }
}

/** True while baseline report or tuning run is still computing. */
export function isAccuracyStatusInProgress(status: string): boolean {
  return (
    status === 'queued' ||
    status === 'running' ||
    status === 'detecting' ||
    status === 'matching'
  );
}
